import { Text } from '@noorden-insurtech/alba-design-system';

export type AssistancePackageCardProps = {
  title: string;
  description?: string | null;
};

export function AssistancePackageCard({
  title,
  description,
}: AssistancePackageCardProps) {
  return (
    <div className='flex flex-col items-start p-4 gap-2.5 bg-alba-white-500 border border-alba-gray-400 rounded-xl flex-1'>
      <div className='flex flex-row justify-between items-center gap-[83px] self-stretch'>
        <div className='flex flex-col items-start gap-1 flex-1'>
          <Text className='text-sm font-bold text-alba-black-500 self-stretch'>
            {title}
          </Text>
          {description && (
            <Text className='text-xs text-alba-gray-600 self-stretch'>
              {description}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
}
